import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import HelpButton from "../../HelpContent/HelpButton";
import { pageProps } from "../../helpers/pageProps";
import { useNavigate } from "react-router-dom";

export default function NylasConnection({
  api,
  onChange,
}: {
  api: any;
  onChange: (value: any) => void;
}) {
  const navigate = useNavigate();
  const [isConnectButtonDisabled, setIsConnectButtonDisabled] = useState(true);
  // connect button should be enabled only if the API profile is saved
  // and has a UUID. This is checked by the useEffect hook.
  useEffect(() => {
    if (!api.Uuid || api.NylasStatus === "connected") {
      setIsConnectButtonDisabled(true);
    } else {
      setIsConnectButtonDisabled(false);
    }
  }, [api]);

  return (
    <div className="my-4">
      <div className="bg-purple-gradient-darker-reverse rounded-4 p-3">
        <h5 className="">Nylas API Connection</h5>

        <Form.Group as={Row} className="mb-3 mt-3" controlId="nylasEmail">
          <Form.Label column sm="4" className="fw-bold">
            Nylas Email: <HelpButton helpKey={"nylas-email" as any} />
          </Form.Label>
          <Col sm="8">
            <Form.Control
              type="email"
              value={api?.NylasEmail}
              name="NylasEmail"
              onChange={(e) => {
                onChange({ ...api, NylasEmail: e.target.value });
              }}
              disabled={api.NylasIsConnected}
            />
          </Col>
        </Form.Group>

        {!api.Uuid && (
          <div className="alert alert-warning">
            You need to save the API profile first to connect to Nylas.
          </div>
        )}

        {api.NylasStatus === "connected" && (
          <div className="alert alert-warning">
            This API is already connected to Nylas.
          </div>
        )}

        {!isConnectButtonDisabled ? (
          <>
            <div className="alert alert-warning">
              When you click the button, you will be redirected to another page
              to authorize the connection.
            </div>
            <a
              href={`${pageProps.workflowsPublicUrl}/webhook/nylas/grant-callback-start/${api.Uuid}/${api.NylasEmail}`}
              className="btn btn-colored rounded-pill"
              target="_blank"
              onClick={() =>
                navigate(`/library/api-connections/${api.Uuid}/status`)
              }
            >
              Connect to Nylas
            </a>
          </>
        ) : (
          <>
            <span className="btn btn-colored rounded-pill disabled">
              Connect to Nylas
            </span>
          </>
        )}
      </div>
    </div>
  );
}
